import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import { Upload as UploadIcon } from 'components/Icons'
import { t } from '@billes/translator-client'
import canUpload from 'utils/canUpload'

export default connect(
  {
    group: state`app.user.group`,
    listType: state`node.listType`,
    selectedNode: state`node.selectedNode`,
    onFilesDropped: signal`media.onFilesDropped`
  },
  class Upload extends Component {
    constructor(props) {
      super(props)
      this.onFileChanged = this.onFileChanged.bind(this)
    }

    onFileChanged(e) {
      e.stopPropagation()
      e.preventDefault()
      if (e.target.files.length > 0) {
        const { onFilesDropped, selectedNode } = this.props
        const files = Array.from(e.target.files).map(file => {
          return file
        })
        onFilesDropped({ files, node: selectedNode })
      }
    }

    render() {
      const { group, listType, selectedNode } = this.props
      if (!canUpload(group)) {
        return null
      }
      const disabled =
        listType === 'HIERARCHICALLY' || !selectedNode || !selectedNode.id
      return (
        <div title={t('bms.media.titles.upload')}>
          <div
            onClick={e => {
              if (disabled) {
                return
              }
              this.fileInput.click()
            }}
            style={{
              marginLeft: 4,
              marginTop: -3,
              cursor: disabled ? 'inherit' : 'pointer'
            }}
          >
            <UploadIcon
              style={{
                fill: disabled ? '#efefef' : 'rgba(0,0,0,0.27)',
                width: 38,
                height: 38
              }}
            />
          </div>
          <input
            type={'file'}
            style={{ display: 'none' }}
            multiple
            ref={input => {
              this.fileInput = input
            }}
            onChange={this.onFileChanged}
          />
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/SwiftMenu/Upload/upload.js